import React, { useState, useRef } from "react";
import { useQuery } from "@apollo/client";
import { NavLink, Route } from "react-router-dom";
import { FaShareAlt } from "react-icons/fa";
import client from "client";

import CatalogContainer from "./CatalogContainer";
import Sources from "./Sources";
import { QUERY_SOURCES } from "pages/SourcePage/SourcesQueries";

export const SourceContext = React.createContext();

const SourcesMasterPage = (props) => {
  const [buttonSourceClass, setButtonSourceClass] = useState();
  const [setButtonCatalogClass] = useState();

  const node = useRef();

  const { loading, error, data, refetch } = useQuery(QUERY_SOURCES, {
    client,
    variables: {
      tenantID: parseInt(localStorage.defaultTenantID),
    },
  });

  const value = {
    enableSourceButton: () => {
      setButtonSourceClass("enable-button");
    },
    disableSourceButton: () => {
      setButtonSourceClass("disable-button");
    },
    enableCatalogButton: () => {
      setButtonCatalogClass("enable-button");
    },
    disableCatalogButton: () => setButtonCatalogClass("disable-button"),
    node: node,
    data: data,
    refetchSources: () => {
      refetch();
    },
    loading: () => {
      loading();
    },
    error: () => {
      error();
    },
  };

  return (
    <SourceContext.Provider value={value}>
      <div className="container-wrapper source-wrapper">
        <div className="container-fluid">
          <main className="container-main">
            <div className="d-flex flex-row">
              <div className="mt-4">
                <div
                  className="vertical-nav mr-0 col py-1  text-center"
                  ref={node}
                >
                  <div className={buttonSourceClass}>
                    <NavLink
                      to="/settings/sources"
                      className="nav-item col px-4 py-3"
                      activeClassName="activeRoute"
                    >
                      <FaShareAlt className="icon__source" />
                      Sources
                    </NavLink>
                  </div>
                  {/* <div className={buttonCatalogClass}>
                    {localStorage.roles &&
                      localStorage.roles.includes("admin") && (
                        <div className="py-1">
                          <NavLink
                            to="/settings/catalog"
                            className="nav-item col px-4 py-3"
                            activeClassName="activeRoute"
                          >
                            <FaBuromobelexperte className="icon__source" />
                            Catalog
                          </NavLink>
                        </div>
                      )}
                  </div> */}
                </div>
              </div>
              <div className="w-100">
                {/* Routes goes here */}
                <Route path="/settings/sources" component={Sources} />
                <Route path="/settings/catalog" component={CatalogContainer} />
              </div>
            </div>
          </main>
        </div>
      </div>
    </SourceContext.Provider>
  );
};

export default SourcesMasterPage;
